'use client';
import React from 'react'
import PrimaryButton from '../PrimaryButton/PrimaryButton'
import CompactButton from '../CompactButton/CompactButton'
import { X } from '@phosphor-icons/react'
import Image from 'next/image'
import { useIsLg } from '@/contexts/BreakpointContext';

interface PopupProps {
	image: string
	imageAlt: string
	heading: string
	text: string
	button: string
	hint: string
	onClose?: () => void
}

// TODO: this has a hardcoded fixed width value

const Popup: React.FC<PopupProps> = ({
	image,
	imageAlt,
	heading,
	text,
	button,
	hint,
	onClose
}) => {
	const isLg = useIsLg();

	return (
		<div className='
			z-100
			!outline-secondary
			!outline-theme-yellow-primary-base
			border-radius-main
			w-[20.625rem]
			lg:w-[32rem]
			bg-bg-light-tertiary'>
			<div className='
				relative
				h-[10.25rem] lg:h-[16.25rem]
				'>
				<Image src={image} alt={imageAlt}
				fill
				sizes="(min-width: 992px) 32rem, 20.625rem"
				loading="eager"
				className='
				border-radius-main
				!outline-secondary
				!outline-theme-yellow-primary-base
				'
				style={{ objectFit: 'cover' }}
				/>
				<CompactButton radius={9999} size={isLg ? 44 : 36}
					onClick={onClose}
					absolute={true}
					className='
					top-[1rem] lg:top-[1.25rem]
					right-[1rem] lg:right-[1.25rem]
					'>
					<X />
				</CompactButton>

			</div>

			<div className='
				px-[1.5rem] 
				lg:px-[2.5rem] 
				py-[2rem]
				lg:py-[2.5rem]
				flex flex-col gap-[2rem]
				'>

				<div className='flex flex-col 
					gap-[1rem]
					lg:gap-[1.25rem]
					items-center justify-center text-center'>
					<p className='
						text-36-to-24--neue-june
						text-text-primary
 						break-words
					'>
						{heading}
					</p>
					<p className='
						text-16-to-14--alexandria
						text-text-tertiary
						 break-words
						'>
						{text}
					</p>
				</div>

				<div className='flex flex-col 
					gap-[0.75rem]
					lg:gap-[1rem]
					items-center justify-center'>
					<PrimaryButton text={button} size={isLg ? 56 : 52} type="accent" icon={false} />
					<p className='
						text-14--alexandria
						text-text-quaternary
						'>
						{hint}
					</p>
				</div>
			</div>
		</div>
	)
}

export default Popup;
